import { Component, OnInit, ViewChild, ElementRef, HostBinding, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { GeocodeService } from 'src/app/services/geocode.service';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
// @ts-ignore
import { LngLat, LngLatBounds } from '!mapbox-gl';
import { Decorable } from 'src/app/types/decorable';
import { SLMap } from 'src/app/model/sl-map';
import { DictHandler, GeoLoc } from 'src/app/types/@types/sl-v-types';
import { StreetInputComponent } from '../street-input/street-input.component';

export type GeoCodeTarget = 'address' | 'xstreets' | 'place';

@Component({
  selector: 'app-geocode',
  templateUrl: './geocode.component.html',
  styleUrls: ['./geocode.component.scss']
})

export class GeocodeComponent implements OnInit {
  public street: Decorable = {};
  public model: any = {};
  public searching = false;
  public searchFailed = false;
  public value: Decorable = {};
  public xstreet: Decorable = {};
  public currentView: 'single-input' | 'x-streets' = 'single-input'
  private map: SLMap;
  private okHandler: DictHandler;
  public attribution = '';
  private isActive: boolean = false;
  public showInstructions: boolean = false;
  public hasStreet(): boolean {
    if (this.currentView === 'single-input') {
      return !!this.value;
    }
    return false;
  }
  public hasXStreet(): boolean {
    if (this.currentView === 'x-streets') {
      return !!this.hasXStreet;
    }
  }
  private _isAdvanced: boolean = false;
  @Input('isAdvanced')
  public set isAdvanced(adv: boolean) {
    if (this._isAdvanced === adv) return;
    this._isAdvanced = adv;
  }
  public get isAdvanced(): boolean {
    return this._isAdvanced;
  }
  @HostBinding('class.active') set active(isActive: boolean) {
    isActive = isActive;
    if (this.isActive === true) {
      (this.locSearchGroup.nativeElement.getElementsByClassName('loc-search')[0] as HTMLElement).focus();
    }
  };
  @ViewChild('streetInput', { static: true }) streetInput: StreetInputComponent;
  @ViewChild('locSearchGrp', { static: true }) locSearchGroup: ElementRef<HTMLDivElement>;
  @ViewChild(NgbTypeahead, { static: true }) locSearch: NgbTypeahead;
  @ViewChild('extentsCB', { static: true }) extentsCB: ElementRef;
  @ViewChild('form', { static: true }) form: ElementRef;

  private _selectedTarget: GeoCodeTarget = 'address';
  public set selectedTarget(target: GeoCodeTarget) {
    this._selectedTarget = target;
    switch (target) {
      case 'address':
      case 'place':
        this.currentView = 'single-input';
        break;
      default:
        this.currentView = 'x-streets';
        break;
    }
  }
  public get selectedTarget(): GeoCodeTarget {
    return this._selectedTarget
  }
  public get isStreetTarget(): boolean {
    switch (this._selectedTarget) {
      case 'place':
        return false;
      default:
        return true;
    }
  }
  public get isPlaceTarget(): boolean {
    switch (this._selectedTarget) {
      case 'place':
        return true;
      default:
        return false;
    }
  }
  get currentValue() {
    const pointZoom = SLMap.POINT_ZOOM;;
    const streetZoom = SLMap.STREET_ZOOM;
    const xsectnZoom  = SLMap.XSECTN_ZOOM;
    switch (this._selectedTarget) {
      case 'place':
      case 'address':
        {
          let zoomLevel = (!!this.value?.bbox) ? undefined : ((this.value?.properties?.accuracy === 'street') ? streetZoom : pointZoom)
          if (!!this.value) {
            const geoLoc: GeoLoc = {
              limitToExtent: false,
              point: {
                lng: this.value.center[0],
                lat: this.value.center[1]
              },
              bbox: this.value?.bbox ? this.value?.bbox : undefined,
              zoom: zoomLevel
            }
            return geoLoc;
          }
        }
        break;
      default:
        {
          if(!this.xstreet?.center) {
            return undefined; 
          }
          let zoomLevel =xsectnZoom;

          if (!!this.xstreet) {
            const geoLoc: GeoLoc = {
              limitToExtent: false,
              point: {
                lng: this.xstreet.center[0],
                lat: this.xstreet.center[1]

              },
              zoom: zoomLevel
            }
            return geoLoc;
          }
          return undefined;
        }
    }

  }
  get autoZoom() {
    return '';
  }
  constructor(private service: GeocodeService) { }

  GetSearchParams(): any {
    const params: Decorable = {};
    params.autoComplete = true;
    params.limitExtents = false;
    const mapCenter = this.map?.ui?.getCenter();
    if (!!mapCenter) {
      params.proximity = mapCenter.lng + ',' + mapCenter.lat;
    }
    if (this.extentsCB.nativeElement.checked) {
      params.limitExtents = true;
      const bounds: LngLatBounds = this.map.ui.getBounds();
      params.bbox = [
        Math.min(bounds.getWest(), bounds.getEast()),
        Math.min(bounds.getNorth(), bounds.getSouth()),
        Math.max(bounds.getWest(), bounds.getEast()),
        Math.max(bounds.getNorth(), bounds.getSouth())
      ];
    }
    return params;
  }

  SetView(which: 'x-streets' | 'single-input') {
    this.currentView = which;

  }
  SetUp(slMap: SLMap, okHandler: DictHandler) {
    this.map = slMap;
    this.okHandler = okHandler;
    this.streetInput?.Setup();
    this.Focus();
  }
  ngOnInit() {

    /*this.locSearch.selectItem.subscribe((event: NgbTypeaheadSelectItemEvent) => {
      this.attribution = this.service.lastResults.attribution;
      $('#locSearch').attr('title', this.attribution);
      if (event.item.hasOwnProperty('bbox')) {
        this.value.bbox = event.item.bbox;
      }
      this.value.point = new LngLat(event.item.center[0], event.item.center[1]);
    });
    $('#locSearch').on('keyup', null, (event: any) => {
      switch (event.keyCode) {
        case 13:
          if (this.okHandler) {
            this.okHandler(this.value);

          }
          break;
      }
    });
    */
    this.extentsCB.nativeElement.addEventListener('onclick', () => {
      this.value.limitToExtent = this.extentsCB.nativeElement.value;
    });

  }
  Focus() {
    window.requestAnimationFrame(() => {
      (this.locSearchGroup.nativeElement.getElementsByClassName('loc-search')[0] as HTMLElement).focus();
    });
  }




}
